import { useTranslation } from 'next-i18next';
import { useViewport } from '@/hooks';
import { ArrowRightIcon } from '@/icons';
import { useQuizListItemProvider } from '@/shared/quizList/hooks';
import { useQuizListItemAction } from '@/shared/quizList/hooks/useQuizListItemAction';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
import { LockBadge } from './LockBadge';
export const QuizListItemThumbnail = () => {
  const {
    isPortable
  } = useViewport();
  const {
    quizSet,
    menuItems
  } = useQuizListItemProvider();
  const isLockQuiz = quizSet.isLocked;
  const hasOwnEnterEvent = menuItems.some(d => d.onClickEventName === 'enter');
  const hoverHasEnterPlay = hasOwnEnterEvent && !isPortable;
  return <div className={cn('relative shrink-0 items-center w-[137px] h-[90px] rounded-md', 'max-tablet-lg:w-[79px] max-tablet-lg:h-[51.6px] max-tablet-lg:rounded-sm')} data-sentry-component="QuizListItemThumbnail" data-sentry-source-file="QuizListItemThumbnail.tsx">
      <img className={cn('shrink-0 max-tablet-lg:rounded-sm rounded-md')} src={quizSet.templateImageUrl} alt="templateThumbNail" />
      {hoverHasEnterPlay && <div className={cn('absolute top-0 size-full max-tablet-lg:rounded-sm rounded-md', 'group-hover:bg-dimmed group-hover:backdrop-blur-[2px]')} />}
      {hoverHasEnterPlay && !isLockQuiz && <HoverEnterPlayButton />}
      {isLockQuiz && <LockBadge className={cn('left-1/2 top-1/2 size-[36px] -translate-x-1/2 -translate-y-1/2', 'tablet-lg:left-[6px] tablet-lg:top-[6px] tablet-lg:size-[40px] tablet-lg:translate-x-0 tablet-lg:translate-y-0')} />}
    </div>;
};
const HoverEnterPlayButton = () => {
  const {
    quizSet
  } = useQuizListItemProvider();
  const {
    onClickEvent
  } = useQuizListItemAction(quizSet);
  const {
    t
  } = useTranslation(['common']);
  return <Button rounded={'full'} size={'sm'} rightSlot={<ArrowRightIcon size={'xs'} />} variant={'contained'} onClick={e => {
    onClickEvent('enter');
    e.preventDefault();
  }} className={cn('invisible group-hover:visible  group-hover:bg-[rgba(28,_27,_31,_0.54)] absolute left-1/2 top-1/2 size-[36px] -translate-x-1/2 -translate-y-1/2', 'w-auto z-10')} data-sentry-element="Button" data-sentry-component="HoverEnterPlayButton" data-sentry-source-file="QuizListItemThumbnail.tsx">
      {t('global.enter.button')}
    </Button>;
};